import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import {
	CampaignToCall,
	CampaignsAdmin,
} from 'src/app/core/models/campaigns.models';
import { CallerService, SortColumn } from '../../services/caller/caller.service';
import {
	NgbdOrdersSortableHeader,
	SortDirection,
} from '../forecast/listjs-sortable-forecast-list.directive';

export interface SortEvent {
	column: SortColumn;
	direction: SortDirection;
}

@Component({
	selector: 'app-callers',
	templateUrl: './callers.component.html',
	styleUrls: ['./callers.component.scss'],
})
export class CallersComponent implements OnInit {
	@ViewChildren(NgbdOrdersSortableHeader)
	headers!: QueryList<NgbdOrdersSortableHeader>;
	ListJsListCampaigns$!: Observable<CampaignToCall[]>;
	total$: Observable<number>;

	constructor(public callerCampaignService: CallerService) {
		this.ListJsListCampaigns$ = callerCampaignService.list_result$;
		this.total$ = callerCampaignService.total$;
	}

	ngOnInit() {}

	getCampaignsForCallers() {}

	onSort({ column, direction }: SortEvent) {
		// resetting other headers
		this.headers.forEach((header) => {
			if (header.sortable !== column) {
				header.direction = '';
			}
		});

		this.callerCampaignService.sortColumn = column;
		this.callerCampaignService.sortDirection = direction;
	}
}
